export const {
  REACT_APP_BACKEND_GRAPHQL_ENDPOINT,
  REACT_APP_BASE_RES_URL,
  REACT_APP_AWS_ENDPOINT,
  REACT_APP_AWS_ACCESS_KEY_ID,
  REACT_APP_AWS_SECRET_ACCESS_KEY,
  REACT_APP_BUCKET_NAME,
  REACT_APP_AWS_REGION,
} = process.env;
